module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-ppt-160f0ae0782a51552bf01d6565524454.svg";